import React from 'react';
import { Link } from 'react-router-dom';
import { FiAlertTriangle } from 'react-icons/fi';

const NotFound = () => {
  return (
    <div className="flex min-h-screen items-center justify-center px-4">
      <div className="w-full max-w-xl rounded-[32px] border border-slate-200 bg-white px-8 py-12 text-center shadow-[0_24px_70px_rgba(15,23,42,0.08)]">
        <div className="flex justify-center mb-6">
          <FiAlertTriangle size={80} className="text-primary" />
        </div>
        <h1 className="text-5xl font-bold text-secondary mb-4">404</h1>
        <h2 className="text-2xl font-semibold text-secondary mb-6">Halaman Tidak Ditemukan</h2>
        <p className="text-gray-600 mb-8 max-w-md mx-auto">
          Maaf, halaman yang Anda cari tidak dapat ditemukan. Halaman mungkin telah dipindahkan atau dihapus.
        </p>
        <Link to="/" className="btn btn-primary px-8">
          Kembali ke Beranda
        </Link>
      </div>
    </div>
  );
};

export default NotFound; 
